import { render, staticRenderFns } from "./crownColorDropdown.vue?vue&type=template&id=16c02990&scoped=true&"
import script from "./crownColorDropdown.vue?vue&type=script&lang=js&"
export * from "./crownColorDropdown.vue?vue&type=script&lang=js&"
import style0 from "./crownColorDropdown.vue?vue&type=style&index=0&id=16c02990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c02990",
  null
  
)

export default component.exports